// ICS Calendar file generator
export class ICS {
    private readonly separator: string;
    private events: string[];
    private readonly start: string;
    private readonly end: string;

    constructor() {
        this.separator = navigator.appVersion.indexOf('Win') !== -1 ? '\r\n' : '\n';
        this.events = [];

        this.start =
            [
                'BEGIN:VCALENDAR',
                'VERSION:2.0',
                'BEGIN:VTIMEZONE',
                'TZID:Europe/Berlin',
                'BEGIN:DAYLIGHT',
                'DTSTART:19810329T020000',
                'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU',
                'TZNAME:MESZ',
                'TZOFFSETFROM:+0100',
                'TZOFFSETTO:+0200',
                'END:DAYLIGHT',
                'BEGIN:STANDARD',
                'DTSTART:19961027T030000',
                'RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU',
                'TZNAME:MEZ',
                'TZOFFSETFROM:+0200',
                'TZOFFSETTO:+0100',
                'END:STANDARD',
                'END:VTIMEZONE',
            ].join(this.separator) + this.separator;

        this.end = this.separator + 'END:VCALENDAR';
    }

    /**
     * Add event to calendar
     */
    addEvent(
        subject: string,
        description: string,
        location: string,
        start: string,
        end: string
    ): ICS {
        const formattedStart = start.replace(/[-:]/g, '').replace(/ /g, 'T');
        const formattedEnd = end.replace(/[-:]/g, '').replace(/ /g, 'T');

        const event = [
            'BEGIN:VEVENT',
            'CLASS:PUBLIC',
            'DESCRIPTION:' + description,
            'DTSTART;TZID=Europe/Berlin:' + formattedStart,
            'DTEND;TZID=Europe/Berlin:' + formattedEnd,
            'LOCATION:' + location,
            'SUMMARY;LANGUAGE=de-DE:' + subject,
            'TRANSP:TRANSPARENT',
            'END:VEVENT',
        ].join(this.separator);

        this.events.push(event);
        return this;
    }

    /**
     * Download ICS file
     */
    download(filename: string = 'event.ics'): ICS {
        if (this.events.length < 1) {
            return this;
        }

        const content = this.start + this.events.join(this.separator) + this.end;
        const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
        const url = URL.createObjectURL(blob);

        // For Android and other mobile browsers, try to open with intent
        if (/Android/.test(navigator.userAgent)) {
            // Try to open the file directly, which may trigger calendar app
            const newWindow = window.open(url, '_blank');

            // Fallback to download if opening fails
            if (newWindow) {
                setTimeout(() => {
                    URL.revokeObjectURL(url);
                }, 100);

                return this;
            }
        }

        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);

        setTimeout(() => {
            URL.revokeObjectURL(url);
        }, 100);

        return this;
    }
}
